module.exports = __webpack_public_path__ + "img/aischool.cac017bd.png";